module.exports = __webpack_public_path__ + "img/acter.237816d5.png";